import { GetListResponse, FeatureInformation } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { Signal } from "@core/services/http/http.type";

class _FeatureInformationService {
  public get(signal?: Signal) {
    return HttpService.get<GetListResponse<FeatureInformation>>(
      "/user/api/v2/feature-information",
      { signal }
    );
  }
}

const FeatureInformationService = new _FeatureInformationService();

export default FeatureInformationService;
